// extracted by css-extract-rspack-plugin
export default {"wrapper":"_4cf29cd6"};